import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/common/content.module.scss';
import CustomStyles from '../../styles/pages/careers.module.scss'
import parse from 'html-react-parser'
import { Hidden } from '@mui/material';
import Image from '../common/Image';
import Button from "../common/ui-components/input/Button"

const LifeAtOnsitego = (props) => {
    const { IsSubtitle, heading, paragraph } = props;
    return (
        <Section className={`${styles.who_are_we} whoarewe ${styles.careers__page}`} hasPadding={true}>
            <div className="container">
                <div className={`row`}>
                    <div className={IsSubtitle ? `${styles.imagesmall} col-12  col-lg-6` : `${styles.image} col-12  col-lg-6`}>
                        <Hidden mdUp>
                        {IsSubtitle && <p className={`${styles.bluehead}`}>ABOUT</p>}
                        <div><h4 className={styles.header}>{heading || "Welcome To Life @Onsitego"}</h4></div>

                        </Hidden>
                        <Image src={"/static/images/careers/welcome_life_onsitego.png"|| ''} alt={"Life @ onsitego"} width="672" height="582" />
                    </div>
                    <div className={`${styles.textcontent} ${CustomStyles.life__at__onsitego} col-12 col-lg-6`}>
                        <Hidden mdDown>
                        {IsSubtitle && <p className={`${styles.bluehead}`}>ABOUT</p>}
                        <div><h4 className={styles.header}>{heading || "Welcome To Life @Onsitego"}<em className="title-el-cap"></em></h4></div>

                        </Hidden>
                        <p className={`${styles.para4}`}>{paragraph ? parse(paragraph) : "A great workplace combines colleagues who’re like family and a new challenge each day. Do you think you have what it takes to face challenges to turn our customer’s experience into a WOW experience? If yes, this is the place for you!"}</p>

                        <p className={`${styles.para4}`}>{paragraph ? parse(paragraph) : "At Onsitego, we are constantly working on creating a working environment that combines uncompromising integrity with professional excellence. We are looking for those with exceptional dynamism, both as team leaders and players, to deliver phenomenal business results."}</p>

                        <p className={`${styles.para4}`}>{paragraph ? parse(paragraph) : "Onsitegoers represent the key to our success and we are constantly looking for passionate and energetic individuals to share in our vision of being the most customer obsessed company in the world."}</p>
                        <div className={`${CustomStyles.open_position__button}`} id="view-postions">
                            <Button text="View Open Positions" onClick={(e)=>{
                                e.preventDefault()
                                 document.querySelector("#job-listing")?.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'nearest',
                                })
                            }} />
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
}

export default LifeAtOnsitego;